// This is only here to enable hot-reloading of styles.
// annoying webpack quirk.

import "../sass/legacy.scss";

// import "./modules/carousel.js";

console.log("legacy.js");
